import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../api";
import { useAuth } from "../AuthContext";

const inputCls = "w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0047AB]/20 focus:border-[#0047AB] disabled:bg-slate-50 disabled:text-slate-500";
const labelCls = "text-xs font-semibold uppercase tracking-wider text-slate-600";

const FIELDS = [
  ["name", "Company Name *", true], ["legal_name", "Legal Name", false], ["gstin", "GSTIN *", true],
  ["address1", "Address Line 1 *", true], ["address2", "Address Line 2", false],
  ["city", "City *", true], ["pincode", "Pincode *", true],
  ["state", "State *", true], ["state_code", "State Code *", true],
  ["email", "E-Mail", false], ["phone", "Phone", false],
  ["bank_name", "Bank Name", false], ["bank_account", "Bank A/c No.", false],
  ["bank_ifsc", "IFSC", false], ["bank_branch", "Branch", false],
];

export default function Company() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/company").then((r) => setForm({ ...Object.fromEntries(FIELDS.map(([k]) => [k, ""])), ...r.data })); }, []);
  if (!form) return <div className="text-slate-500 text-sm">Loading...</div>;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/company", form);
      toast.success("Company details saved");
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="company-page" className="max-w-3xl space-y-6">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Setup</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit" }}>Company</h1>
        <p className="text-sm text-slate-500 mt-1">Invoices are raised from this company. {!isAdmin && "Only Admin can edit."}</p>
      </div>
      <form onSubmit={save} className="bg-white border border-slate-200 rounded-lg p-5 sm:p-6 grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, req]) => (
          <div key={k} className={["name", "address1", "address2"].includes(k) ? "sm:col-span-2" : ""}>
            <label className={labelCls}>{label}</label>
            <input data-testid={`company-${k}-input`} required={req} disabled={!isAdmin} value={form[k] || ""}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })} className={`${inputCls} mt-1`} />
          </div>
        ))}
        {isAdmin && (
          <div className="sm:col-span-2 flex justify-end">
            <button data-testid="company-save-btn" disabled={busy}
              className="bg-[#0047AB] hover:bg-[#003380] text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-colors duration-200 disabled:opacity-60">
              {busy ? "Saving..." : "Save Company"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
